// src/store/konceptsSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getAllKoncepts } from "../api/kentyouEye";

// Async thunk to fetch all koncepts
export const fetchAllKoncepts = createAsyncThunk(
  "koncepts/fetchAll",
  async (_, { rejectWithValue }) => {
    try {
      const json = await getAllKoncepts();
      // JSON has shape { data: [ { id, name, location, kapabilities: [...] }, … ], pagination: {...} }
      return json.data;
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);

const konceptsSlice = createSlice({
  name: "koncepts",
  initialState: {
    items: [],         // array of all koncepts
    status: "idle",    // "idle" | "loading" | "succeeded" | "failed"
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllKoncepts.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchAllKoncepts.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.items = action.payload;
      })
      .addCase(fetchAllKoncepts.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});

export default konceptsSlice.reducer;
